export const SET_SCHEDULED_MESSAGES = "SET_SCHEDULED_MESSAGES";
export const ADD_SCHEDULED_MESSAGE = "ADD_SCHEDULED_MESSAGE";
export const DELETE_SCHEDULED_MESSAGE = "DELETE_SCHEDULED_MESSAGE";
export const UPDATE_SCHEDULED_MESSAGE = "UPDATE_SCHEDULED_MESSAGE";
